import { defineMessages } from 'react-intl';

/**
 * Will have the messages displayed in the SelectFromWaitlist modal
 */
const messages = defineMessages({
  fundingPrograms: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.FundingPrograms',
    defaultMessage: 'Funding Programs',
  },
  fundingProgramsTooltip: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.FundingProgramsTooltip',
    defaultMessage: 'Funding programs assigned to this waitlist.',
  },
  bedrooms: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.Bedrooms',
    defaultMessage: 'Bedrooms',
  },
  qualificationFloorPlan: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.QualificationFloorPlan',
    defaultMessage: 'Qualification Floor Plan',
  },
  qualificationFloorPlanTooltip: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.QualificationFloorPlanTooltip',
    defaultMessage:
      'Select a floor plan that will be used to initially qualify this applicant for ' +
      'affordable housing. The floor plan may be changed during the qualification process.',
  },
  floorPlanPrograms: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.FloorPlanPrograms',
    defaultMessage: 'Floor Plan Programs',
  },
  floorPlanProgramsTooltip: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.FloorPlanProgramsTooltip',
    defaultMessage: 'The funding programs assigned to this floorplan',
  },
  preferredMoveInDate: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.PreferredMoveInDate',
    defaultMessage: 'Preferred Move-in Date',
  },
  preferredMoveInDateTooltip: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.PreferredMoveInDateTooltip',
    defaultMessage:
      'Preferred move-in date will be used for determining rents and income limits. ' +
      'The Scheduled Move-in date will default to this date and may be changed prior to leasing.',
  },
  confirm: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.Confirm',
    defaultMessage: 'Confirm',
  },
  reason: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.Reason',
    defaultMessage: 'Reason',
  },
  notes: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.Notes',
    defaultMessage: 'Notes',
  },
  notesRequired: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.NotesRequired',
    defaultMessage: 'Notes are required when (Other - See Notes) is selected',
  },
  limitReached255: {
    id: 'App.ManageAffordableWaitlistV2.SelectFromWaitlist.LimitReached255',
    defaultMessage:
      'Your note exceeds the 255 character limit. Please shorten your text.',
  },
});

export default messages;
